(function() {
    var require, requirejs, module, exports, define;
